export const guardarFechaLocal = ({clave, fecha}) => {

    let claveFecha = 'fecha' + clave

    let dataString = JSON.stringify(fecha)

    window.localStorage.setItem(claveFecha, dataString)


}